export const messageConstants = {
  successfullyCreatedUpdated: 'This instruction has been submitted!',
  successfullyCanceled: 'The instruction was successfully canceled.',
  successfullyStopped: 'The instruction was successfully stopped.',
  errorCancelingStopping: 'Something went wrong. Please try again or contact your service team if the problem persists.',
  errorCreatingUpdating: 'Could not process your request, please try again.',
  hardEditNotificationHeading:
    'Due to the following error that would be received when the resulting trade is placed. This instruction cannot be set up. Please modify your entries or ensure the error is resolved before attempting to set this instruction up again.',
  softEditNotificationHeading:
    'Please review the following warnings about the resulting trades corresponding to this instruction.',
  executeTransactionOn: 'Execute transaction on',
  noTradeDataAccessHeading: 'You do not have trading authority on this account because of your permissions.',
  noTradeDataAccessMessage:
    "If you believe this is incorrect, or to access additional functionality, contact your company's Firm Security Administrator."
};
